var prisma = prisma || {};
(function ($) {

    if (!$) {
        return;
    }

    /* MELHORIAS JQUERY ***************************************************/

    // prisma.ajax -> uses $.ajax ------------------------------------------------

    prisma.ajax = function (userOptions) {
        userOptions = userOptions || {};

        var options = $.extend({}, prisma.ajax.defaultOpts, userOptions);
        options.success = undefined;
        options.error = undefined;

        return $.Deferred(function ($dfd) {
            $.ajax(options)
                .done(function (data, textStatus, jqXHR) {
                    if (data.__prisma) {
                        prisma.ajax.handleResponse(data, userOptions, $dfd, jqXHR);
                    } else {
                        $dfd.resolve(data);
                        userOptions.success && userOptions.success(data);
                    }
                }).fail(function (jqXHR) {
                    if (jqXHR.responseJSON && jqXHR.responseJSON.__prisma) {
                        prisma.ajax.handleResponse(jqXHR.responseJSON, userOptions, $dfd, jqXHR);
                    } else {
                        prisma.ajax.handleNonprismaErrorResponse(jqXHR, userOptions, $dfd);
                    }
                });
        });
    };

    $.extend(prisma.ajax, {
        defaultOpts: {
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json'
        },

        defaultError: {
            message: 'Ocorreu um erro!',
            details: 'Detalhes do erro não enviados pelo servidor.'
        },

        defaultError401: {
            message: 'Você não está autenticado!',
            details: 'Você deve estar autenticado (log in) para realizar esta operação.'
        },

        defaultError403: {
            message: 'Você não está autorizado!',
            details: 'Você não tem permissão para realizar esta operação.'
        },

        defaultError404: {
            message: 'Recurso não encontrado!',
            details: 'O recurso solicitado não pode ser encontrado no servidor.'
        },

        logError: function (error) {
            prisma.log.error(error);
        },

        showError: function (error) {
            if (error.details) {
                return prisma.message.error(error.details, error.message);
            } else {
                return prisma.message.error(error.message || prisma.ajax.defaultError.message);
            }
        },

        handleTargetUrl: function (targetUrl) {
            if (!targetUrl) {
                location.href = prisma.appPath;
            } else {
                location.href = targetUrl;
            }
        },

        handleNonprismaErrorResponse: function (jqXHR, userOptions, $dfd) {
            if (userOptions.prismaHandleError !== false) {
                switch (jqXHR.status) {
                    case 401:
                        prisma.ajax.handleUnAuthorizedRequest(
                            prisma.ajax.showError(prisma.ajax.defaultError401),
                            prisma.appPath
                        );
                        break;
                    case 403:
                        prisma.ajax.showError(prisma.ajax.defaultError403);
                        break;
                    case 404:
                        prisma.ajax.showError(prisma.ajax.defaultError404);
                        break;
                    default:
                        prisma.ajax.showError(prisma.ajax.defaultError);
                        break;
                }
            }

            $dfd.reject.apply(this, arguments);
            userOptions.error && userOptions.error.apply(this, arguments);
        },

        handleUnAuthorizedRequest: function (messagePromise, targetUrl) {
            if (messagePromise) {
                messagePromise.done(function () {
                    prisma.ajax.handleTargetUrl(targetUrl);
                });
            } else {
                prisma.ajax.handleTargetUrl(targetUrl);
            }
        },

        handleResponse: function (data, userOptions, $dfd, jqXHR) {
            if (data) {
                if (data.success === true) {
                    $dfd && $dfd.resolve(data.result, data, jqXHR);
                    userOptions.success && userOptions.success(data.result, data, jqXHR);

                    if (data.targetUrl) {
                        prisma.ajax.handleTargetUrl(data.targetUrl);
                    }
                } else if (data.success === false) {
                    var messagePromise = null;

                    if (data.error) {
                        if (userOptions.prismaHandleError !== false) {
                            messagePromise = prisma.ajax.showError(data.error);
                        }
                    } else {
                        data.error = prisma.ajax.defaultError;
                    }

                    prisma.ajax.logError(data.error);

                    $dfd && $dfd.reject(data.error, jqXHR);
                    userOptions.error && userOptions.error(data.error, jqXHR);

                    if (jqXHR.status === 401 && userOptions.prismaHandleError !== false) {
                        prisma.ajax.handleUnAuthorizedRequest(messagePromise, data.targetUrl);
                    }
                } else { //resultado não encapsulado
                    $dfd && $dfd.resolve(data, null, jqXHR);
                    userOptions.success && userOptions.success(data, null, jqXHR);
                }
            } else { //nenhum dado enviado de volta
                $dfd && $dfd.resolve(jqXHR);
                userOptions.success && userOptions.success(jqXHR);
            }
        },

        blockUI: function (options) {
            if (options.blockUI) {
                if (options.blockUI === true) { //bloqueio a página inteira
                    prisma.ui.setBusy();
                } else { //bloqueia um elemento
                    prisma.ui.setBusy(options.blockUI);
                }
            }
        },

        unblockUI: function (options) {
            if (options.blockUI) {
                if (options.blockUI === true) { //desbloqueia a página inteira
                    prisma.ui.clearBusy();
                } else { //desbloqueio um elemento
                    prisma.ui.clearBusy(options.blockUI);
                }
            }
        },

        ajaxSendHandler: function (event, request, settings) {
            if (!settings.headers || settings.headers[prisma.security.antiForgery.tokenHeaderName] === undefined) {
                request.setRequestHeader(prisma.security.antiForgery.tokenHeaderName, prisma.security.antiForgery.getToken());
            }
        }
    });

    $(document).ajaxSend(function (event, request, settings) {
        return prisma.ajax.ajaxSendHandler(event, request, settings);
    });

    /* MELHORIAS DE JQUERY PLUGIN ********************************************/

    /* jQuery Form Plugin 
     * http://www.malsup.com/jquery/form/
     */

    // prismaAjaxForm -> uses ajaxForm ------------------------------------------

    if ($.fn.ajaxForm) {
        $.fn.prismaAjaxForm = function (userOptions) {
            userOptions = userOptions || {};

            var options = $.extend({}, $.fn.prismaAjaxForm.defaults, userOptions);

            options.beforeSubmit = function () {
                prisma.ajax.blockUI(options);
                userOptions.beforeSubmit && userOptions.beforeSubmit.apply(this, arguments);
            };

            options.success = function (data) {
                prisma.ajax.handleResponse(data, userOptions);
            };

            //TODO: Erro?

            options.complete = function () {
                prisma.ajax.unblockUI(options);
                userOptions.complete && userOptions.complete.apply(this, arguments);
            };

            return this.ajaxForm(options);
        };

        $.fn.prismaAjaxForm.defaults = {
            method: 'POST'
        };
    }

})(jQuery);